import React, { useEffect } from 'react';
import classNames from 'classnames';
import useApi from '../../../hooks/useApi';
import slugify from '../../../utils/slugify';
import B2bLocationGraphic from '../../../assets/landing/b2bLocationGraphic.png';
import './styles.css';

const B2bLocation = ({ location, state, b2bStyle }) => {
  const { fetch, data: { data } = {} } = useApi('B2BLocations');

  const { name, url } = (data && data[0]) || {};

  useEffect(() => {
    fetch({
      params: {
        name: slugify(location),
        state: slugify(state),
      },
    });
  }, []);

  return (
    <div>
      <div
        className={classNames('Landing__B2bLocation', {
          [`Landing__B2bLocation--${b2bStyle}`]: b2bStyle,
        })}
      >
        <div>
          <img src={B2bLocationGraphic} alt="Landing__B2bLocation" />
        </div>
        <div>
          <div className="Landing__B2bLocation__title">
            There&apos;s a Localsearch Digital Marketing Service Near You
          </div>
          <div className="Landing__B2bLocation__text">
            With digital marketing specialists throughout Australia, we tailor
            everything to suit you, your business and your location.
          </div>
          <a
            href={
              name !== location
                ? 'https://business.localsearch.com.au/contact-us/'
                : url
            }
          >
            {name !== location ? 'Find out more' : 'Find your location'}{' '}
            <i className="icon-generalcaretrightmedium" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default B2bLocation;
